import { Modal } from "antd";
import React, { useState } from "react";
import img from "../../../../../../../assets/img/pos/no-img.jpg";
import { URL_API } from "../../../../../../../utils";
import { useRouteMatch } from "react-router-dom";

const ImagePreview = ({ id, src, visible, onCancel }) => {
  const match = useRouteMatch();
  const [errImg, setErrImg] = useState(null);
  return (
    <Modal
      zIndex={1081}
      footer={false}
      width={800}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose={true}
    >
      <div className="w-100 d-flex justify-content-center my-5">
        <img
          src={
            errImg
              ? errImg
              : id
              ? `${URL_API}${
                  match.params.id === "0"
                    ? "/system/products/image/"
                    : "/setting/master/product-request/image/"
                }${id}/preview`
              : src
          }
          className="w-100 h-100 object-fit-cover"
          alt="promotion"
          onError={() => setErrImg(img)}
        />
      </div>
    </Modal>
  );
};

export default React.memo(ImagePreview);
